export default __webpack_public_path__ + "7b65b0c5bdd7a8731dd8beeeead57c72.svg";